import MaterialBox, { BoxProps } from "@mui/material/Box";

export function Card(props: BoxProps & { children?: any; style?: React.CSSProperties }) {
  return <MaterialBox bgcolor="white" borderRadius={4} boxShadow="9px 9px 12px -7px #aaaaaa" {...props} />;
}
